export const SAVE_FOR_LATER_ITEMS_COUNT = 'saveForLaterItemsCount';

export type ServiceSaveForLaterQueries = {
    [SAVE_FOR_LATER_ITEMS_COUNT]: undefined;
};

export type ServiceSaveForLaterQueriesResponseType = {
    [SAVE_FOR_LATER_ITEMS_COUNT]: number;
};
